import { render, staticRenderFns } from "./footer-slider.vue?vue&type=template&id=2d8e0746&scoped=true&"
import script from "./footer-slider.vue?vue&type=script&lang=js&"
export * from "./footer-slider.vue?vue&type=script&lang=js&"
import style0 from "./footer-slider.vue?vue&type=style&index=0&id=2d8e0746&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e0746",
  null
  
)

export default component.exports